import { useCallback, useEffect } from 'react';
export const useRefetchOnWindowFocus = ({
  refetch,
  loading
}) => {
  const onWindowFocus = useCallback(() => {
    if (!loading) {
      refetch();
    }
  }, [refetch, loading]);
  useEffect(() => {
    window.addEventListener('focus', onWindowFocus);
    return () => {
      window.removeEventListener('focus', onWindowFocus);
    };
  }, [onWindowFocus]);
};